import React from 'react';
import S from './style'
import Logo from '../../assets/logo.svg'
import TranslateStatic from '../../locales/TranslateStatic'
function AsrmEshre(props) {
    return (
        <S.Wrapper>
            <S.Section>
                <h2><TranslateStatic string="AsrmEshreBaslik" /></h2>
                <a className='dislink' target="_blank" href='https://www.eshre.eu/Guidelines-and-Legal/Patients'>
                    <img src='https://www.eshre.eu/-/media/Images/default/Logo_Eshre_v2.png?h=1042&iar=0&w=1968&hash=8FB32A66E7BC59B65D798A8FC3624769' />
                    <TranslateStatic string="Eshre" />
                </a>
                <a className='dislink' target="_blank" href='https://www.asrm.org/'>
                    <img src='https://www.asrm.org/globalassets/_asrm/logo.svg' />
                    <TranslateStatic string="Asrm" />
                </a>
                {/* <span><TranslateStatic string="callinfo" /><a className='call' href="tel:05316425793">📞</a></span> */}

            </S.Section>
        </S.Wrapper >
    );
}

export default AsrmEshre;